<template>
  <div class="z-10 h-full min-h-0 flex flex-col">
    <div class="mb-8 flex-shrink-0">
      <base-toggle-group :tabs="editorTabs"
                         v-model="editorMode"
      />
    </div>

    <div class="flex-1 min-h-0">
      <transition name="fade" mode="out-in">
        <settings-bot-theme-json v-if="editorMode === EDITOR_MODE.CODE"
                                 :key="activeTabKey"
                                 class="col-span-8 mt-3 h-full overflow-y-auto"
                                 v-model="themeValue"
                                 @update:json-validity="$emit('update:json-validity', $event)"
        />
        <settings-bot-theme-form v-else
                                 class="h-full"
                                 v-model="themeValue"
                                 :image-cache.sync="imageCacheValue"
        />
      </transition>
    </div>
  </div>
</template>

<script>
import SettingsBotThemeJson from '@/components/settings/bot-theme/SettingsBotThemeJson.vue'
import BaseToggleGroup from '@/components/base-components/BaseToggleGroup.vue'
import SettingsBotThemeForm from '@/components/settings/bot-theme/SettingsBotThemeForm.vue'
import isNil from 'ramda/src/isNil'

const EDITOR_MODE = Object.freeze({
  CLASSIC: 'classic',
  CODE: 'code'
})

const EDITOR_TABS = Object.freeze([
  { key: EDITOR_MODE.CLASSIC, label: 'Classic Editor' },
  { key: EDITOR_MODE.CODE, label: 'Code Editor' }
])

export default {
  name: 'SettingsBotThemeEditor',

  components: {
    SettingsBotThemeForm,
    BaseToggleGroup,
    SettingsBotThemeJson
  },

  props: {
    activeTabKey: {
      type: String,
      default: ''
    },
    value: {
      type: Object,
      default: () => {}
    },
    imageCache: {
      type: Object,
      required: true
    }
  },

  emits: ['input'],

  data() {
    return {
      EDITOR_MODE,
      editorMode: EDITOR_MODE.CLASSIC,
      editorTabs: EDITOR_TABS
    }
  },

  computed: {
    imageCacheValue: {
      get() {
        return this.imageCache
      },
      set(newImageCache) {
        this.$emit('update:image-cache', newImageCache)
      }
    },
    themeValue: {
      get() {
        return this.value
      },
      set({ name, themeConfig, langConfig, launcherImageUrl }) {
        if (themeConfig) {
          this.$emit('input', { themeConfig })
        }
        if (!isNil(name)) {
          this.$emit('input', { name })
        }
        if (langConfig) {
          this.$emit('input', { langConfig })
        }
        if (!isNil(launcherImageUrl)) {
          this.$emit('input', { launcherImageUrl })
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
